module.exports = __webpack_public_path__ + "img/ic-tiktok-partner.e1b1d089.svg";